@file:OptIn(InternalResourceApi::class)

package chartsproject.app.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/chartsproject.app.generated.resources/"

@delegate:ResourceContentHash(-359_204_268)
public val Res.string.app_name: StringResource by lazy {
      StringResource("string:app_name", "app_name", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 24),
      ))
    }

@delegate:ResourceContentHash(2_520_111)
public val Res.string.bar_chart: StringResource by lazy {
      StringResource("string:bar_chart", "bar_chart", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 35, 21),
      ))
    }

@delegate:ResourceContentHash(-1_221_129_702)
public val Res.string.bar_data_points: StringResource by lazy {
      StringResource("string:bar_data_points", "bar_data_points", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 119, 47),
      ))
    }

@delegate:ResourceContentHash(-1_006_863_214)
public val Res.string.bar_data_points_range: StringResource by lazy {
      StringResource("string:bar_data_points_range", "bar_data_points_range", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 57, 61),
      ))
    }

@delegate:ResourceContentHash(-605_905_374)
public val Res.string.bar_stacked_chart: StringResource by lazy {
      StringResource("string:bar_stacked_chart", "bar_stacked_chart", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 167, 41),
      ))
    }

@delegate:ResourceContentHash(2_111_655_811)
public val Res.string.cd_close_dialog: StringResource by lazy {
      StringResource("string:cd_close_dialog", "cd_close_dialog", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 209, 39),
      ))
    }

@delegate:ResourceContentHash(1_885_197_310)
public val Res.string.cd_close_settings: StringResource by lazy {
      StringResource("string:cd_close_settings", "cd_close_settings", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 249, 45),
      ))
    }

@delegate:ResourceContentHash(1_513_011_259)
public val Res.string.cd_hide_parameters: StringResource by lazy {
      StringResource("string:cd_hide_parameters", "cd_hide_parameters", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 295, 46),
      ))
    }

@delegate:ResourceContentHash(-507_690_378)
public val Res.string.cd_navigate_back: StringResource by lazy {
      StringResource("string:cd_navigate_back", "cd_navigate_back", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 342, 32),
      ))
    }

@delegate:ResourceContentHash(1_886_444_647)
public val Res.string.cd_open_settings: StringResource by lazy {
      StringResource("string:cd_open_settings", "cd_open_settings", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 375, 44),
      ))
    }

@delegate:ResourceContentHash(-1_573_909_759)
public val Res.string.cd_open_style_details: StringResource by lazy {
      StringResource("string:cd_open_style_details", "cd_open_style_details", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 420, 53),
      ))
    }

@delegate:ResourceContentHash(-821_830_830)
public val Res.string.cd_pause_live_updates: StringResource by lazy {
      StringResource("string:cd_pause_live_updates", "cd_pause_live_updates", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 474, 53),
      ))
    }

@delegate:ResourceContentHash(669_827_369)
public val Res.string.cd_play_live_updates: StringResource by lazy {
      StringResource("string:cd_play_live_updates", "cd_play_live_updates", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 528, 52),
      ))
    }

@delegate:ResourceContentHash(1_505_974_269)
public val Res.string.cd_refresh_data: StringResource by lazy {
      StringResource("string:cd_refresh_data", "cd_refresh_data", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 581, 39),
      ))
    }

@delegate:ResourceContentHash(-984_300_785)
public val Res.string.cd_regenerate_chart: StringResource by lazy {
      StringResource("string:cd_regenerate_chart", "cd_regenerate_chart", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 621, 51),
      ))
    }

@delegate:ResourceContentHash(1_685_346_227)
public val Res.string.cd_select_theme: StringResource by lazy {
      StringResource("string:cd_select_theme", "cd_select_theme", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 673, 47),
      ))
    }

@delegate:ResourceContentHash(-708_718_065)
public val Res.string.cd_show_parameters: StringResource by lazy {
      StringResource("string:cd_show_parameters", "cd_show_parameters", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 721, 46),
      ))
    }

@delegate:ResourceContentHash(-492_944_298)
public val Res.string.chart_basic: StringResource by lazy {
      StringResource("string:chart_basic", "chart_basic", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 768, 27),
      ))
    }

@delegate:ResourceContentHash(29_589_604)
public val Res.string.chart_custom: StringResource by lazy {
      StringResource("string:chart_custom", "chart_custom", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 796, 28),
      ))
    }

@delegate:ResourceContentHash(-640_381_755)
public val Res.string.chart_default: StringResource by lazy {
      StringResource("string:chart_default", "chart_default", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 825, 33),
      ))
    }

@delegate:ResourceContentHash(1_906_250_625)
public val Res.string.chart_timeline: StringResource by lazy {
      StringResource("string:chart_timeline", "chart_timeline", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 859, 34),
      ))
    }

@delegate:ResourceContentHash(2_553_393)
public val Res.string.dark_mode_off: StringResource by lazy {
      StringResource("string:dark_mode_off", "dark_mode_off", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 894, 25),
      ))
    }

@delegate:ResourceContentHash(2_552_167)
public val Res.string.dark_mode_on: StringResource by lazy {
      StringResource("string:dark_mode_on", "dark_mode_on", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 920, 24),
      ))
    }

@delegate:ResourceContentHash(-959_261_427)
public val Res.string.dark_mode_system: StringResource by lazy {
      StringResource("string:dark_mode_system", "dark_mode_system", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 945, 32),
      ))
    }

@delegate:ResourceContentHash(-861_724_022)
public val Res.string.drawer_dark_mode_subtitle: StringResource by lazy {
      StringResource("string:drawer_dark_mode_subtitle", "drawer_dark_mode_subtitle", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 978, 53),
      ))
    }

@delegate:ResourceContentHash(-1_811_490_972)
public val Res.string.drawer_dynamic_colors_disable_hint: StringResource by lazy {
      StringResource("string:drawer_dynamic_colors_disable_hint", "drawer_dynamic_colors_disable_hint", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1032, 98),
      ))
    }

@delegate:ResourceContentHash(1_077_194_467)
public val Res.string.drawer_dynamic_colors_subtitle: StringResource by lazy {
      StringResource("string:drawer_dynamic_colors_subtitle", "drawer_dynamic_colors_subtitle", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1131, 70),
      ))
    }

@delegate:ResourceContentHash(-75_263_042)
public val Res.string.drawer_github_subtitle: StringResource by lazy {
      StringResource("string:drawer_github_subtitle", "drawer_github_subtitle", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1202, 74),
      ))
    }

@delegate:ResourceContentHash(1_752_823_957)
public val Res.string.drawer_header_subtitle: StringResource by lazy {
      StringResource("string:drawer_header_subtitle", "drawer_header_subtitle", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1277, 62),
      ))
    }

@delegate:ResourceContentHash(2_128_440_428)
public val Res.string.drawer_header_title: StringResource by lazy {
      StringResource("string:drawer_header_title", "drawer_header_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1340, 39),
      ))
    }

@delegate:ResourceContentHash(54_228_438)
public val Res.string.drawer_section_appearance: StringResource by lazy {
      StringResource("string:drawer_section_appearance", "drawer_section_appearance", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1380, 49),
      ))
    }

@delegate:ResourceContentHash(-2_136_593_858)
public val Res.string.drawer_section_links: StringResource by lazy {
      StringResource("string:drawer_section_links", "drawer_section_links", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1430, 36),
      ))
    }

@delegate:ResourceContentHash(1_226_263_246)
public val Res.string.drawer_section_themes: StringResource by lazy {
      StringResource("string:drawer_section_themes", "drawer_section_themes", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1467, 37),
      ))
    }

@delegate:ResourceContentHash(1_997_915_644)
public val Res.string.drawer_title_dark_mode: StringResource by lazy {
      StringResource("string:drawer_title_dark_mode", "drawer_title_dark_mode", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1505, 42),
      ))
    }

@delegate:ResourceContentHash(-1_212_443_219)
public val Res.string.drawer_title_dynamic_colors: StringResource by lazy {
      StringResource("string:drawer_title_dynamic_colors", "drawer_title_dynamic_colors", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1548, 55),
      ))
    }

@delegate:ResourceContentHash(1_445_892_428)
public val Res.string.drawer_title_github: StringResource by lazy {
      StringResource("string:drawer_title_github", "drawer_title_github", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1604, 35),
      ))
    }

@delegate:ResourceContentHash(433_035_716)
public val Res.string.github_url: StringResource by lazy {
      StringResource("string:github_url", "github_url", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1703, 70),
      ))
    }

@delegate:ResourceContentHash(1_429_505_610)
public val Res.string.github_url_content_description: StringResource by lazy {
      StringResource("string:github_url_content_description", "github_url_content_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1640, 62),
      ))
    }

@delegate:ResourceContentHash(-2_136_774_061)
public val Res.string.line_chart: StringResource by lazy {
      StringResource("string:line_chart", "line_chart", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1774, 26),
      ))
    }

@delegate:ResourceContentHash(-1_221_129_702)
public val Res.string.line_data_points: StringResource by lazy {
      StringResource("string:line_data_points", "line_data_points", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1864, 48),
      ))
    }

@delegate:ResourceContentHash(-1_006_863_214)
public val Res.string.line_data_points_range: StringResource by lazy {
      StringResource("string:line_data_points_range", "line_data_points_range", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1801, 62),
      ))
    }

@delegate:ResourceContentHash(2_086_110_003)
public val Res.string.multi_line_chart: StringResource by lazy {
      StringResource("string:multi_line_chart", "multi_line_chart", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1913, 40),
      ))
    }

@delegate:ResourceContentHash(2_603_922)
public val Res.string.pie_chart: StringResource by lazy {
      StringResource("string:pie_chart", "pie_chart", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1954, 21),
      ))
    }

@delegate:ResourceContentHash(-2_125_727_856)
public val Res.string.radar_chart: StringResource by lazy {
      StringResource("string:radar_chart", "radar_chart", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1976, 27),
      ))
    }

@delegate:ResourceContentHash(-606_510_358)
public val Res.string.stacked_area_chart: StringResource by lazy {
      StringResource("string:stacked_area_chart", "stacked_area_chart", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2004, 42),
      ))
    }

@delegate:ResourceContentHash(-1_221_129_702)
public val Res.string.stacked_area_data_points: StringResource by lazy {
      StringResource("string:stacked_area_data_points", "stacked_area_data_points", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2118, 56),
      ))
    }

@delegate:ResourceContentHash(-1_006_863_214)
public val Res.string.stacked_area_data_points_range: StringResource by lazy {
      StringResource("string:stacked_area_data_points_range", "stacked_area_data_points_range", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2047, 70),
      ))
    }

@delegate:ResourceContentHash(-1_221_129_702)
public val Res.string.stacked_bar_data_points: StringResource by lazy {
      StringResource("string:stacked_bar_data_points", "stacked_bar_data_points", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2245, 55),
      ))
    }

@delegate:ResourceContentHash(-1_006_863_214)
public val Res.string.stacked_bar_data_points_range: StringResource by lazy {
      StringResource("string:stacked_bar_data_points_range", "stacked_bar_data_points_range", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2175, 69),
      ))
    }

@delegate:ResourceContentHash(2_052_587_384)
public val Res.string.style_details_title: StringResource by lazy {
      StringResource("string:style_details_title", "style_details_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2301, 47),
      ))
    }

@delegate:ResourceContentHash(1_962_339_924)
public val Res.string.themes_content_description: StringResource by lazy {
      StringResource("string:themes_content_description", "themes_content_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2349, 58),
      ))
    }

@delegate:ResourceContentHash(240_348_946)
public val Res.string.timeline_update_interval: StringResource by lazy {
      StringResource("string:timeline_update_interval", "timeline_update_interval", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2408, 64),
      ))
    }

@delegate:ResourceContentHash(518_593_909)
public val Res.string.timeline_window_size: StringResource by lazy {
      StringResource("string:timeline_window_size", "timeline_window_size", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2473, 60),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("app_name", Res.string.app_name)
  map.put("bar_chart", Res.string.bar_chart)
  map.put("bar_data_points", Res.string.bar_data_points)
  map.put("bar_data_points_range", Res.string.bar_data_points_range)
  map.put("bar_stacked_chart", Res.string.bar_stacked_chart)
  map.put("cd_close_dialog", Res.string.cd_close_dialog)
  map.put("cd_close_settings", Res.string.cd_close_settings)
  map.put("cd_hide_parameters", Res.string.cd_hide_parameters)
  map.put("cd_navigate_back", Res.string.cd_navigate_back)
  map.put("cd_open_settings", Res.string.cd_open_settings)
  map.put("cd_open_style_details", Res.string.cd_open_style_details)
  map.put("cd_pause_live_updates", Res.string.cd_pause_live_updates)
  map.put("cd_play_live_updates", Res.string.cd_play_live_updates)
  map.put("cd_refresh_data", Res.string.cd_refresh_data)
  map.put("cd_regenerate_chart", Res.string.cd_regenerate_chart)
  map.put("cd_select_theme", Res.string.cd_select_theme)
  map.put("cd_show_parameters", Res.string.cd_show_parameters)
  map.put("chart_basic", Res.string.chart_basic)
  map.put("chart_custom", Res.string.chart_custom)
  map.put("chart_default", Res.string.chart_default)
  map.put("chart_timeline", Res.string.chart_timeline)
  map.put("dark_mode_off", Res.string.dark_mode_off)
  map.put("dark_mode_on", Res.string.dark_mode_on)
  map.put("dark_mode_system", Res.string.dark_mode_system)
  map.put("drawer_dark_mode_subtitle", Res.string.drawer_dark_mode_subtitle)
  map.put("drawer_dynamic_colors_disable_hint", Res.string.drawer_dynamic_colors_disable_hint)
  map.put("drawer_dynamic_colors_subtitle", Res.string.drawer_dynamic_colors_subtitle)
  map.put("drawer_github_subtitle", Res.string.drawer_github_subtitle)
  map.put("drawer_header_subtitle", Res.string.drawer_header_subtitle)
  map.put("drawer_header_title", Res.string.drawer_header_title)
  map.put("drawer_section_appearance", Res.string.drawer_section_appearance)
  map.put("drawer_section_links", Res.string.drawer_section_links)
  map.put("drawer_section_themes", Res.string.drawer_section_themes)
  map.put("drawer_title_dark_mode", Res.string.drawer_title_dark_mode)
  map.put("drawer_title_dynamic_colors", Res.string.drawer_title_dynamic_colors)
  map.put("drawer_title_github", Res.string.drawer_title_github)
  map.put("github_url", Res.string.github_url)
  map.put("github_url_content_description", Res.string.github_url_content_description)
  map.put("line_chart", Res.string.line_chart)
  map.put("line_data_points", Res.string.line_data_points)
  map.put("line_data_points_range", Res.string.line_data_points_range)
  map.put("multi_line_chart", Res.string.multi_line_chart)
  map.put("pie_chart", Res.string.pie_chart)
  map.put("radar_chart", Res.string.radar_chart)
  map.put("stacked_area_chart", Res.string.stacked_area_chart)
  map.put("stacked_area_data_points", Res.string.stacked_area_data_points)
  map.put("stacked_area_data_points_range", Res.string.stacked_area_data_points_range)
  map.put("stacked_bar_data_points", Res.string.stacked_bar_data_points)
  map.put("stacked_bar_data_points_range", Res.string.stacked_bar_data_points_range)
  map.put("style_details_title", Res.string.style_details_title)
  map.put("themes_content_description", Res.string.themes_content_description)
  map.put("timeline_update_interval", Res.string.timeline_update_interval)
  map.put("timeline_window_size", Res.string.timeline_window_size)
}
